const USER_STORAGE_KEY = 'user';

const isObject = (value) => value !== null && typeof value === 'object';

const getStoredSession = () => {
  const rawValue = localStorage.getItem(USER_STORAGE_KEY);
  if (!rawValue) {
    return null;
  }

  try {
    const parsedValue = JSON.parse(rawValue);
    return isObject(parsedValue) ? parsedValue : null;
  } catch (error) {
    localStorage.removeItem(USER_STORAGE_KEY);
    return null;
  }
};

export const getStoredUser = () => {
  const session = getStoredSession();

  if (!session) {
    return null;
  }

  if (isObject(session.user?.result)) {
    return { ...session.user.result };
  }

  if (isObject(session.user)) {
    return { ...session.user };
  }

  if (isObject(session.result)) {
    return { ...session.result };
  }

  return null;
};

export const getStoredToken = () => {
  const session = getStoredSession();
  const possibleToken =
    session?.token ||
    session?.user?.access_token ||
    session?.user?.result?.access_token ||
    session?.result?.access_token;

  return typeof possibleToken === 'string' && possibleToken.trim() ? possibleToken : null;
};

export const isAuthenticated = (reduxUser = null) => {
  const hasReduxUser = isObject(reduxUser) && Object.keys(reduxUser).length > 0;
  return hasReduxUser || Boolean(getStoredToken());
};

export const checkUser = () => getStoredUser();
